import React, { useState } from 'react';
import classnames from 'classnames';

const Form = ({
  render,
  initialCalculationInputValues,
  onSubmit,
  className,
}) => {
  const [values, setValues] = useState(initialCalculationInputValues);
  const handleInputChange = ({ target }) =>
    target ? setValues({ ...values, [target.name]: target.value }) : null;

  return (
    <form className={classnames('form', className)} onSubmit={onSubmit}>
      {render({ formProps: { handleInputChange, values } })}
    </form>
  );
};

export default Form;
